
import React from 'react';
import { AppMode, Language, User } from '../types';
import NavRailItems from './NavigationRail/NavRailItems';

interface NavigationRailProps {
  currentMode: AppMode;
  onSwitchMode: (mode: AppMode) => void;
  language: Language;
  isOpen: boolean;
  onClose: () => void;
  user: User | null;
}

const NavigationRail: React.FC<NavigationRailProps> = ({ currentMode, onSwitchMode, language, isOpen, onClose, user }) => {
  const isRtl = language === 'ar';

  return (
    <>
      {/* Mobile Backdrop */}
      <div 
        className={`fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] lg:hidden transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} 
        onClick={onClose}
      />

      <nav className={`
        flex flex-col items-center py-6 w-20 bg-[#050507] border-${isRtl ? 'r' : 'l'} border-white/5 z-[101] shrink-0
        fixed lg:static inset-y-0 ${isRtl ? 'left-0' : 'right-0'}
        transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : (isRtl ? '-translate-x-full' : 'translate-x-full')}
        lg:translate-x-0
      `}>
        <div className="mb-8 w-10 h-10 rounded-xl bg-emerald-500 flex items-center justify-center text-white shadow-lg shadow-emerald-500/20 cursor-pointer" onClick={() => { onSwitchMode('chat'); onClose(); }}>
          <img src="logo.png" className="w-6 h-6 object-contain brightness-0 invert" alt="L" />
        </div>

        <NavRailItems 
          currentMode={currentMode}
          onSwitchMode={onSwitchMode}
          onClose={onClose}
          language={language}
          user={user}
        />

        <div className="mt-auto pt-4">
          <button className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-500 hover:text-white transition-colors">
            <i className="fas fa-question text-xs"></i>
          </button>
        </div>
      </nav>
    </>
  );
};

export default NavigationRail;
